import {
  ADD_ON_DETAILS_MODES,
  ADD_ON_DETAILS_QUICK_ACTION_MENU_MODES,
} from '../../Containers/AddOnDetails/AddOnDetails.Enum';

const getQAModeOnPrimaryButtonPress = mode => {
  if (mode === ADD_ON_DETAILS_MODES.REMOVE) {
    return ADD_ON_DETAILS_QUICK_ACTION_MENU_MODES.EDIT;
  } else if (mode === ADD_ON_DETAILS_MODES.BUY) {
    return ADD_ON_DETAILS_QUICK_ACTION_MENU_MODES.BUY;
  }
};

const getQAModeOnSecondaryButtonPress = mode => {
  if (mode === ADD_ON_DETAILS_MODES.REMOVE) {
    return ADD_ON_DETAILS_QUICK_ACTION_MENU_MODES.REMOVE;
  }
};

const getPrimaryButtonTitle = modeType => {
  switch (modeType) {
    case ADD_ON_DETAILS_MODES.REMOVE:
      return 'soho_addons_remove_addon_button_apply_changes_label';
    case ADD_ON_DETAILS_MODES.BUY:
      return 'soho_addons_buy_addon_button_buy_this_addon_label';
  }
};

const getSecondaryButtonTitle = modeType => {
  if (modeType === ADD_ON_DETAILS_MODES.REMOVE) {
    return 'soho_addons_remove_addon_secondary_button_remove_this_addon_label';
  }
};

export {
  getQAModeOnPrimaryButtonPress,
  getQAModeOnSecondaryButtonPress,
  getPrimaryButtonTitle,
  getSecondaryButtonTitle,
};
